module.exports = __webpack_public_path__ + "static/media/awards_14.b1f698cb.jpg";